/**
 * Generic business event names.
 *
 * These are vendor-agnostic — components emit these events without knowing
 * which tracking vendors are listening. Each vendor (Bloomreach, GTM, etc.)
 * subscribes and maps to their own event names/formats.
 */
export const EmitterEvent = {
    /** User adds a product to the basket. */
    ADD_TO_BASKET: 'add_to_basket',
    /** User logs out of their account. */
    LOGOUT: 'logout',
};
